export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-xs font-label uppercase tracking-[0.2em] text-foreground-500 mb-3">
            At a Glance
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            LitBuy Spreadsheet vs Alternatives
          </h2>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-foreground-900 text-background-50">
                <th className="text-left px-5 py-4 font-label font-semibold">Feature</th>
                <th className="text-center px-5 py-4 font-label font-semibold">
                  <span className="text-primary-400">LitBuy Spreadsheet</span>
                </th>
                <th className="text-center px-5 py-4 font-label font-semibold">Manual Tracking</th>
                <th className="text-center px-5 py-4 font-label font-semibold">Basic Excel</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70 bg-background-50">
                <td className="px-5 py-3.5 font-label font-medium text-foreground-800">Ease of Use</td>
                <td className="text-center px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span> High
                  </span>
                </td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Low</td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Medium</td>
              </tr>
              <tr className="border-b border-background-200/70 bg-background-50">
                <td className="px-5 py-3.5 font-label font-medium text-foreground-800">Automation</td>
                <td className="text-center px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span> Yes
                  </span>
                </td>
                <td className="text-center px-5 py-3.5 text-foreground-600">No</td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Limited</td>
              </tr>
              <tr className="border-b border-background-200/70 bg-background-50">
                <td className="px-5 py-3.5 font-label font-medium text-foreground-800">Organization</td>
                <td className="text-center px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span> Excellent
                  </span>
                </td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Poor</td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Average</td>
              </tr>
              <tr className="border-b border-background-200/70 bg-background-50">
                <td className="px-5 py-3.5 font-label font-medium text-foreground-800">Time Saving</td>
                <td className="text-center px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span> High
                  </span>
                </td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Low</td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Medium</td>
              </tr>
              <tr className="bg-background-50">
                <td className="px-5 py-3.5 font-label font-medium text-foreground-800">Scalability</td>
                <td className="text-center px-5 py-3.5">
                  <span className="inline-flex items-center gap-1 text-accent-600 font-semibold">
                    <span className="w-4 h-4 flex items-center justify-center"><i className="ri-check-line"></i></span> High
                  </span>
                </td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Low</td>
                <td className="text-center px-5 py-3.5 text-foreground-600">Medium</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}